import {
  DOCS,
  IDEA_ROOM_TITLE,
  NOTES_ROOM_TITLE,
  OUTLINE_ROOM_TITLE,
} from './writerCopy';
import { SERIES_DISCOVERY_LABEL } from './focusTemplates';
import { isSeriesDiscoveryChat } from './seriesDiscoveryReply';

/**
 * Page title for /chat/:sessionId.
 * Idea stays Idea. A Work-this-sequence chat is Outline work, so it
 * uses the Outline room label. An explicit room key uses that room's
 * existing label.
 */
const ROOM_LABEL_BY_KEY = {
  idea: IDEA_ROOM_TITLE,
  outline: OUTLINE_ROOM_TITLE,
  write: 'Write',
  notes: NOTES_ROOM_TITLE,
  docs: DOCS,
};

const BEAT_NAME_PREFIX = 'Work ';

function namedBeat(session) {
  const workshop = session?.beat_workshop;
  const fromWorkshop = workshop && typeof workshop === 'object' ? workshop.beat_name : '';
  if (String(fromWorkshop || '').trim()) return String(fromWorkshop).trim();
  const meta = session?.metadata;
  const nested = meta && typeof meta === 'object' ? meta.beat_workshop : null;
  const fromMeta = nested && typeof nested === 'object' ? nested.beat_name : '';
  return String(fromMeta || '').trim();
}

/** A Work-this-sequence chat. A Plot Focus the writer named is not one. */
export function isSequenceChatSession(session) {
  if (!session) return false;
  if ((session.guidance_mode || '') !== 'focus') return false;
  const template = session.template || '';
  if (template !== 'plot' && template !== 'scene') return false;
  if (namedBeat(session)) return true;
  const target = String(session.focus_target_name || '').trim();
  const name = String(session.name || '').trim();
  return Boolean(target) && name === `${BEAT_NAME_PREFIX}${target}`;
}

export function chatPageRoomTitle(session) {
  const key = String(session?.room_key || '').toLowerCase();
  if (key && key !== 'idea' && ROOM_LABEL_BY_KEY[key]) return ROOM_LABEL_BY_KEY[key];
  if (isSequenceChatSession(session)) return OUTLINE_ROOM_TITLE;
  if (isSeriesDiscoveryChat({ projectId: session?.project_id, storyId: session?.story_id })) {
    return SERIES_DISCOVERY_LABEL;
  }
  if (ROOM_LABEL_BY_KEY[key]) return ROOM_LABEL_BY_KEY[key];
  return IDEA_ROOM_TITLE;
}
